import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <-- ADICIONE ESTA LINHA
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
